import { IconSvg, IconSvgProps } from "./icon"

export default function ChevronDown(props: IconSvgProps) {
  return (
    <IconSvg {...props} strokeModifier={1.125}>
      <path d="m3.643 7.95 7.907 7.907a.617.617 0 0 0 .9 0l7.907-7.907" />
    </IconSvg>
  )
}
